import * as React from 'react';
import { SVGProps } from 'react';

const SvgEmbossed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.22258 11.702L17.9278 5.72607L21.1194 7.55862L10.3647 13.6189L7.22258 11.702Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M13.2949 29.9543L24.0035 23.976V5.69629L13.295 11.668L13.2949 29.9543Z'
      fill='#FFDECC'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
    <path
      d='M32.7938 14.4173V29.6411L17.9199 21.4418V5.90088L20.9895 7.52375L21.0757 4.00561L24.0053 5.69696V9.34325L32.7938 14.4173Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M13.2949 29.9543L24.0035 23.976V5.69629L13.295 11.668L13.2949 29.9543Z'
      fill='#FFDECC'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
    <path
      d='M22.0828 20.388V35.6118L7.20898 27.4125V11.8716L10.2786 13.4945L10.3648 9.97631L13.2943 11.6677V15.314L22.0828 20.388Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M22.084 35.6121L32.7925 29.6338V14.4143L22.0841 20.386L22.084 35.6121Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M13.4902 15.3563L24.1992 9.38037L32.7928 14.4124L22.0805 20.3867L13.4902 15.3563Z'
      fill='white'
      stroke='black'
      strokeLinejoin='round'
    />
    <path
      d='M10.3652 9.9759L21.0742 4L24.0041 5.692L13.2919 11.6663L10.3652 9.9759Z'
      fill='#FFDECC'
      stroke='#FF4D00'
      strokeLinejoin='round'
    />
    <path
      d='M13.295 11.8706V15.5251L10.3613 13.8325V10.1934L13.295 11.8706Z'
      fill='#FFDECC'
    />
    <path
      d='M13.295 15.31V11.6555L10.3613 9.97827V13.6174'
      stroke='#FF4D00'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgEmbossed;
